<template>
    <div>
        <el-dialog
                title="提现"
                :visible.sync="cashWithdrawal"
                width="400px">
            <el-form :model="form" ref="form" label-width="68px" class="demo-ruleForm">
                <el-form-item label="提现金额" prop="inputMoney">
                    <el-input v-model="form.inputMoney" placeholder="请输入提现金额"></el-input>
                </el-form-item>
                <span class="tips-text">提现最低额度为{{MinimumAmount}}元，当前可提现余额{{balance}}元，</span>
                <el-button size="small" @click="allCash">全部提现</el-button>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="cashWithdrawal = false">取消</el-button>
        <el-button type="primary" @click="confirmCash">提现</el-button>
      </span>
        </el-dialog>
        <div class="balance-detail flex align-items margin-bottom-20">
            <div class="number ff9203">账户余额：<i>￥{{balance}}</i><i v-if="!balance">0.00</i> 元</div>
<!--            <el-button type="primary" @click="toRecharge">立即提现</el-button>-->
        </div>
        <el-table
                :data="list"
                style="width: 100%">
            <el-table-column
                    prop="add_time"
                    label="日期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="income_sn"
                    label="流水单号"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="type"
                    label="类型"
                    width="180">
                <template slot-scope="scope">
                    <span v-show="scope.row.type == 0">佣金收入</span>
                    <span v-show="scope.row.type == 1">余额提现</span>
                    <span v-show="scope.row.type == 4">平台代充值</span>
                    <span v-show="scope.row.type == 5">推荐企业一级佣金</span>
                    <span v-show="scope.row.type == 6">推荐企业二级佣金</span>
                    <span v-show="scope.row.type == 7">推荐达人一级佣金</span>
                    <span v-show="scope.row.type == 8">推荐达人二级佣金</span>
                    <span v-show="scope.row.type == 9">代客下单佣金</span>
                    <span v-show="scope.row.type == 10">企业下单返佣</span>
                    <span v-show="scope.row.type == 11">达人接单返佣</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="money"
                    label="收支金额(元)">
                <template slot-scope="scope">
              <span
                      class="addMoney"
                      v-show="scope.row.type == 0 ||
                        scope.row.type == 4 ||
                        scope.row.type == 5 ||
                        scope.row.type == 6 ||
                        scope.row.type == 7 ||
                        scope.row.type == 8 ||
                        scope.row.type == 9 ||
                        scope.row.type == 10 ||
                        scope.row.type == 11"
              >+{{scope.row.money}}</span>
                    <span class="reduceMoney" v-show="scope.row.type == 1">-{{scope.row.money}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="origin_money"
                    label="账户结余(元)"
                    width="180">
            </el-table-column>
        </el-table>
        <div class="pages">
            <el-pagination
                    @current-change="handleBalancePage"
                    :current-page.sync="balancePage"
                    :page-size="10"
                    layout="prev, pager, next, jumper"
                    :total="balanceTotal"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    import {
        personalBalance,
        withdrawal,
        myDarenInfo,
        addWithdrawal,
        getConfig
    } from '@/config/api.js'
    export default {
        name: 'EnterpriseBalanceDetailed',
        data () {
            return {
                money: '',
                balanceTotal: 0,
                balancePage: 1,
                list: [],
                balance: '',
                cashWithdrawal: false,
                form: {
                    inputMoney: null,
                },
                MinimumAmount: ''
            }
        },
        methods: {
            handleBalancePage(page) {
                this.balancePage = page;
                this.getComBalance();
            },
            getComBalance() {
                let data = {
                    user_type: this.$store.state.user_type,
                    pc_id: this.$store.state.user_id,
                    page: this.balancePage - 1
                };
                this.$post(personalBalance, data)
                    .then(res => {
                        const data = res.data;
                        this.list = data.list;
                        this.balanceTotal = Number(data.count);
                    })
                    .catch(err => {
                        window.console.log("err", err);
                    });
            },
            toRecharge () {
                let data = {
                    user_type: this.$store.state.user_type,
                    pc_id: this.$store.state.user_id,
                    money: this.balance,
                };
                this.$post(withdrawal,data)
                    .then(() => {
                        this.cashWithdrawal = true;
                    })
                    .catch(err => {
                        this.$message.error(err.msg);
                    })
            },
            getMoney () {
                let data = {
                    user_type: this.$store.state.user_type,
                    user_id: this.$store.state.user_id,
                };
                this.$post(myDarenInfo,data)
                    .then(res => {
                        this.balance = res.data.money;
                    })
            },
            allCash () {
              this.form.inputMoney = this.balance;
            },
            confirmCash () {
                if (this.form.inputMoney >= this.MinimumAmount) {
                    let data = {
                        user_type: this.$store.state.user_type,
                        pc_id: this.$store.state.user_id,
                        money: this.form.inputMoney,
                    };
                    this.$post(addWithdrawal,data)
                        .then(res => {
                            this.$message.success(res.msg);
                        })
                        .catch(err => {
                            this.$message.error(err.msg)
                        })
                } else {
                    this.$message.error('最低提现金额不能低于' + this.MinimumAmount + '元')
                }
            },
            getMinimumAmount () {
                let data = {
                    key: 'withdrawal_limit_money'
                };
                this.$post(getConfig,data)
                    .then(res => {
                        this.MinimumAmount = res.data
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            }
        },
        created() {
            this.getComBalance();
            this.getMoney();
            this.getMinimumAmount();
        }
    }
</script>
<style scoped>
    .balance-detail{padding:10px 20px;background: #fff7ed;}
    .balance-detail .number{font-size:16px;margin-right: 20px;}
    .reduceMoney{color:#ff5900;}
    .addMoney{color:#00c250;}
    .tips-text{font-size:12px;}
</style>
